import { useState, useEffect } from 'react';
import {
  getUser,
  getThisDay, getThisWeek, getThisMonth, getThisYear,
  getAvgDay, getAvgWeek, getAvgMonth, getAvgYear
} from '../API';
import PointCard from '../components/PointCard';

const Home = () => {

  const [auth, setAuth] = useState(false);
  const [user, setUser] = useState({});

  const [todayData, setTodayData] = useState('');
  const [weekData, setWeekData] = useState('');
  const [monthData, setMonthData] = useState('');
  const [yrData, setYrData] = useState('');

  const [todayAvgData, setTodayAvgData] = useState('');
  const [weekAvgData, setWeekAvgData] = useState('');
  const [monthAvgData, setMonthAvgData] = useState('');
  const [yrAvgData, setYrAvgData] = useState('');

  useEffect(() => {

    getUser().then(response => {
      if (response != null && response.profileid) {
        setUser(response);
        setAuth(true);

        getThisDay().then(response => {
          setTodayData(response);
        })

        getThisWeek().then(response => {
          setWeekData(response);
        })

        getThisMonth().then(response => {
          setMonthData(response);
        })

        getThisYear().then(response => {
          setYrData(response);
        })

        getAvgDay().then(response => {
          setTodayAvgData(response);
        })

        getAvgWeek().then(response => {
          setWeekAvgData(response);
        })

        getAvgMonth().then(response => {
          setMonthAvgData(response);
        })

        getAvgYear().then(response => {
          setYrAvgData(response);
        })

      } else {
        setAuth(false);
      }
    })

  }, []);


  const handleLogin = () => {
    window.location.href = '/login';
  }

  const todayLabel = (() => {
    const raw = new Date().toLocaleDateString('fr-CA', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
    return raw.charAt(0).toUpperCase() + raw.slice(1);
  })();

  return auth === true ? (
    <div className="container home-dashboard-page">
      <header className="home-dashboard-header">
        <p className="page-eyebrow">Accueil</p>
        <h1>Bonjour {user.prenom}</h1>
        <p className="page-lead">Résumé de l'activité récente · {todayLabel}</p>
      </header>

      <section className="home-kpi-section" aria-labelledby="home-activity-title">
        <div className="home-kpi-section-head">
          <h2 id="home-activity-title">Activité récente</h2>
          <p>Points enregistrés sur les périodes en cours</p>
        </div>
        <div className="kpi-grid">
          <PointCard
            title="Aujourd'hui"
            data={todayData}
            footer="Points entrés"
            icon="fa-calendar-week"
            accent="blue"
          />
          <PointCard
            title="Cette semaine"
            data={weekData}
            footer="Points entrés"
            icon="fa-calendar-week"
            accent="indigo"
          />
          <PointCard
            title="Ce mois-ci"
            data={monthData}
            footer="Points entrés"
            icon="fa-calendar-week"
            accent="teal"
          />
          <PointCard
            title="Cette année"
            data={yrData}
            footer="Points entrés"
            icon="fa-calendar-week"
            accent="amber"
          />
        </div>
      </section>

      <section className="home-kpi-section" aria-labelledby="home-average-title">
        <div className="home-kpi-section-head">
          <h2 id="home-average-title">Moyennes</h2>
          <p>Volume moyen de points sur chaque période</p>
        </div>
        <div className="kpi-grid">
          <PointCard
            title="Par jour"
            data={todayAvgData}
            footer="Points entrés"
            icon="fa-calendar-week"
            accent="blue"
          />
          <PointCard
            title="Par semaine"
            data={weekAvgData}
            footer="Points entrés"
            icon="fa-calendar-week"
            accent="indigo"
          />
          <PointCard
            title="Par mois"
            data={monthAvgData}
            footer="Points entrés"
            icon="fa-calendar-week"
            accent="teal"
          />
          <PointCard
            title="Par année"
            data={yrAvgData}
            footer="Points entrés"
            icon="fa-calendar-week"
            accent="amber"
          />
        </div>
      </section>
    </div>
  ) : (
    <>
      <div className="container page-container">
        <div className="page-card home-landing">
          <header className="home-landing-header">
            <span className="home-landing-icon" aria-hidden="true">
              <i className="fas fa-microscope"></i>
            </span>
            <h1>Medcodes</h1>
            <p className="home-landing-lead">
              Application gratuite de préfacturation pour les pathologistes du Québec.
            </p>
            <p className="home-landing-sublead">
              Enregistrez vos cas au fil de la journée, suivez vos points et générez
              des rapports prêts pour la saisie sur le site de la RAMQ.
            </p>
          </header>

          <div className="row home-landing-content">
            <div className="col-sm-12 col-lg-6 order-2 order-lg-1 home-landing-features">
              <div className="home-features">
                <div className="home-feature-item">
                  <div className="home-feature-icon" aria-hidden="true">
                    <i className="fas fa-edit"></i>
                  </div>
                  <div className="home-feature-content">
                    <h3>Préfacturation</h3>
                    <p>Saisissez rapidement les codes de pathologie des cas complétés, au fur et à mesure.</p>
                  </div>
                </div>

                <div className="home-feature-item">
                  <div className="home-feature-icon" aria-hidden="true">
                    <i className="fas fa-list"></i>
                  </div>
                  <div className="home-feature-content">
                    <h3>Rapports</h3>
                    <p>Historique clair, formaté pour faciliter la facturation sur le site de la RAMQ.</p>
                  </div>
                </div>

                <div className="home-feature-item">
                  <div className="home-feature-icon" aria-hidden="true">
                    <i className="fas fa-chart-bar"></i>
                  </div>
                  <div className="home-feature-content">
                    <h3>Statistiques</h3>
                    <p>Volume de points par semaine, par mois et par type de cas complété.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-sm-12 col-lg-6 order-1 order-lg-2 home-landing-auth d-flex justify-content-center align-items-start">
              <div className="auth-actions-box">
                <h2 className="auth-actions-title">Accéder à Medcodes</h2>
                <p className="auth-actions-subtitle">Connectez-vous ou créez un compte pour commencer.</p>
                <button onClick={handleLogin} className="btn btn-primary btn-block auth-actions-btn">
                  Se connecter
                </button>
                <a href="/signup" className="btn btn-outline-primary btn-block auth-actions-btn">
                  Créer un compte
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Home;
